import type Module from "@kestrel/path";
import { webJoin } from "@otto-ec/assets-core-utils/url";
import { base } from "@kestrel/path";
import { getServerRequestContext, type ContextThis } from "@kestrel/internal/context";

export const baseUrl = function (this: ContextThis, uri?) {
  /*                                                        */
  const origin = import.meta.env.SSR ? getServerRequestContext(this).req.url : location.origin;

  /*                                                                   */
  /*                                                                    */
  const uBase = new URL(base, origin);
  if (!uri) return uBase;

  /*                                                 */
  /*                                                               */
  const uUri = new URL(uri, uBase);
  if (uUri.pathname.startsWith(base)) return uUri;

  /*                                             */
  return webJoin(uBase, uri);
} satisfies typeof Module.baseUrl;
